<!--
 功能名称:NavBar 导航栏
 开发人:梁高权
 创建时间:2021/03/13
 最后修改时间:2021/03/13
-->
<template>
  <van-nav-bar
    :title="$route.meta.title"
    left-text="返回"
    left-arrow
    :fixed="true"
    :placeholder="true"
    @click-left="onClickLeft"
  />
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'NavBar',
  methods: {
    onClickLeft() {
      this.$router.go(-1);//返回上一层
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .van-nav-bar__left{
    i{color: #666}
    span{color: #666}
  }
</style>
